module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAAXNSR0IArs4c6QAAAUpJREFUKBWtU7GKg0AQfV5SC2mEVBHBVEkpaYSAkMo+oF9h4Q+kEv2PmC59mlQGUsVvCGm0CAEFLUTvsh67uEkKOW6anX0zb97OOArfT8MfbNjlnE4nRFGEwWDQhVu/rmsYhgFN035jRJGa53nU/XgGQcDwr25pQRC61ze/G+eeOpvN4DgOyrLE7XaDKIp4PB6QZRlN02C9XrNinKJpmhiPx1AUBZIktf2MRiNMp1MQtdVq9ZnI0B4Op9gjn6VwPR4OB5zP5zaYJAnyPMf1ekVVVUjTFMfjsf0kJIEj7vd7uK7Lqr46u93uM9GyLPi+D13XMZ/PGS/LMmy3W26qnKKqqphMJlgsFlgul4x4v99BtopMmhpHpGAYhqxXghVFgefK0HB7/s9UaUnbtt+eutlsaPhdkfwVcRxjOOQ7IPjlcuFwgaw7V6rn5QeGT5q+ICOoDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/comedor.png
// module id = 498
// module chunks = 0